import BuySide from './BuySide.component';

export default BuySide;
